import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {MyNewsTabType} from '../../../graphql/generated/types';
import {MY_NEWS_SLICE_NAME} from '../constant';
import {MyNewsState} from '../type';
import {selectTabStateKeyByTabType} from './selector';

const INITIAL_MY_NEWS_STATE: MyNewsState = {
  all: {needRefresh: true},
  my: {needRefresh: true},
  up: {needRefresh: true},
  updatedMyNewsIdList: [],
};

export const myNewsSlice = createSlice({
  name: MY_NEWS_SLICE_NAME,
  initialState: INITIAL_MY_NEWS_STATE,
  reducers: {
    setUpdatedMyNewsIdList: (
      state,
      action: PayloadAction<{updatedMyNewsIdList: number[]}>
    ): void => {
      state.updatedMyNewsIdList = action.payload.updatedMyNewsIdList;
    },
    setNeedRefresh: (
      state,
      action: PayloadAction<{tabType: MyNewsTabType; needRefresh: boolean}>
    ): void => {
      const {tabType, needRefresh} = action.payload;
      const currentTab = selectTabStateKeyByTabType(tabType);
      state[currentTab].needRefresh = needRefresh;
    },
    setAllNeedRefresh: (state): void => {
      state['all'].needRefresh = true;
      state['my'].needRefresh = true;
      state['up'].needRefresh = true;
    },
  },
});

export const {setUpdatedMyNewsIdList, setNeedRefresh, setAllNeedRefresh} =
  myNewsSlice.actions;
